import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationGroup } from 'src/app/interfaces/applicationGroup';
import { Groups } from 'src/app/interfaces/groups';
import { URL } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GroupModalService {
  private readonly http = inject(HttpClient);

  /***************************************************👌
   * Get the application of the Group                 *
   * @param applicationId The ID of the application.  *
   * @returns {Observable<any>}                       *
   ****************************************************/
  getApplicationGroupById(applicationId: number): Observable<ApplicationGroup> {
    return this.http.get<ApplicationGroup>(`${URL.url}applicationGroup/${applicationId}`);
  }

  /*****************************************************👌
   * Adds a group by ID.                                *
   * @param applicationId - The ID of the application.  *
   * @param data - The data to add.                     *
   * @returns {Observable<any>}                         *
   ******************************************************/
  addGroupById(applicationId: number, data: Groups): Observable<void> {
    const body = JSON.stringify(data);
    const headers = { 'content-type': 'application/json' };
    return this.http.put<void>(`${URL.url}${URL.applications}/${applicationId}/${URL.group}`, body, { headers });
  }
}
